// JsFromRoutes CacheKey 4921d5e703edd4d99b54754d12ecd159
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  updateEntitlement: /* #__PURE__ */ definePathHelper('patch', '/god-mode/plans/:id/update_entitlement'),
  updatePrice: /* #__PURE__ */ definePathHelper('patch', '/god-mode/plans/:id/update_price'),
  index: /* #__PURE__ */ definePathHelper('get', '/god-mode/plans'),
  show: /* #__PURE__ */ definePathHelper('get', '/god-mode/plans/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/god-mode/plans/:id'),
}
